import { visitOne, visitTwo, wxSdkInfo } from '../../api/api';
import axios from 'axios';
import { Toast } from 'vant';
// 获取url地址查询参数
function getQueryString(name: string) {
  const queryString = window.location.search.substr(1);
  const queryArray = queryString.split('&');
  let result = null;
  queryArray.forEach((i) => {
    const itemArray = i.split('=');
    if (itemArray[0] === name) {
      result = decodeURIComponent(itemArray[1]);
    }
  });
  return result;
}
// 判断是否是微信浏览器
function isWeiXin() {
  const reg = /MicroMessenger/g;
  const ua = window.navigator.userAgent;
  return reg.test(ua);
}
// 判断是不是手机
function isMobile() {
  const userAgentInfo = navigator.userAgent;
  const Agents: string[] = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ];
  let flag = false;
  for (const v of Agents) {
    if (userAgentInfo.indexOf(v) > -1) {
      flag = true;
      break;
    }
  }
  return flag;
}
// 是否自动打开
function autoOpenApp() {
  if (!isWeiXin() && !window.udid) {
    window.location.href =
      'shangyounews://{"dt":"7","url":"' + location.href + '"}';
  } else {
    return;
  }
}

// 数组分类
const groupBy = (key: string) => (array: any[]) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

// 新版app分享
export interface ShareOption {
  title: string;
  url: string;
  subtitle?: string;
  classId: number | string; // -1
  id: number | string; // -1
  image?: string;
  type: any; // 3 | 6 | 11 | 12 | 13 | 16
}

const appShare = (data: ShareOption) => {
  setTimeout(() => {
    const option = {
      action: 'mSetShareInfo',
      data: JSON.stringify(data),
    };
    if (window.handleMessage) {
      window.handleMessage(JSON.stringify(option));
    }
  }, 500);
};
// 获取微信sdk
function wxConfig(statement: object) {
  window.wx.config({
    debug: false,
    ...statement,
    jsApiList: [
      // 所有要调用的 API 都要加到这个列表中
      'updateAppMessageShareData', // 分享到朋友
      'updateTimelineShareData', // 分享到朋友圈
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
    ],
  });
}
// 分享图片处理
function getCoverImage(post: any) {
  if (post.image) {
    return post.image;
  } else {
    return 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
  }
}
interface IWxShareOption {
  title: string;
  subtitle: string;
  link?: string;
  image?: string;
}
// 微信分享
function wxShareInfo(DetailsData: IWxShareOption) {
  wxSdkInfo({ jssdkurl: window.location.href }).then((res: any) => {
    const data = res.data;
    // console.log(DetailsData);
    const e = DetailsData;
    const messageData = {
      title: e.title, // 分享标题
      desc: e.subtitle, // 分享描述
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: getCoverImage(e), // 分享图标
    };
    wxConfig(data);
    window.wx.ready(() => {
      window.wx.updateAppMessageShareData({
        ...messageData,
      });
      window.wx.updateTimelineShareData({
        ...messageData,
      });
    });
  });
}
// 添加pv
function addPv(e: number | string) {
  if (process.env.NODE_ENV === 'production') {
    axios.get(
      `http://vote.cqcb.com/e/public/ViewClick/?classid=9&id=${e}&addclick=1`,
    );
    axios.get(
      `http://vote.cqcb.com/e/public/onclick/?enews=donews&classid=${e}&id=1`,
    );
  } else {
    console.log('添加pv成功');
  }
}
export {
  getQueryString,
  isWeiXin,
  isMobile,
  autoOpenApp,
  groupBy,
  appShare,
  addPv,
  wxShareInfo,
};
